import { SEO, SITE } from "../data/seo";

const CANONICAL_HOSTS = ["jakeferree.com", "www.jakeferree.com"];

const upsert = (selector, make) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = make();
    document.head.appendChild(el);
  }
  return el;
};

const meta = (attr, key, content) => {
  const el = upsert(`meta[${attr}="${key}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(attr, key);
    return m;
  });
  el.setAttribute("content", content);
};

export const applySeo = (pathname, fallbackTitle, fallbackDescription) => {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const s = SEO[path];
  const title = s?.title ?? fallbackTitle;
  const description = s?.description ?? fallbackDescription ?? "";
  document.title = title;
  meta("name", "description", description);
  meta("name", "robots", s && CANONICAL_HOSTS.includes(window.location.hostname) ? "index, follow" : "noindex, nofollow");

  const canonical = document.head.querySelector('link[rel="canonical"]');
  if (s) {
    const link = canonical || document.head.appendChild(Object.assign(document.createElement("link"), { rel: "canonical" }));
    link.href = `${SITE}${path === "/" ? "/" : path}`;
  } else if (canonical) canonical.remove();

  const url = s ? `${SITE}${path === "/" ? "/" : path}` : `${SITE}/`;
  const image = s?.image ?? SEO["/"].image;
  [["og:title", title], ["og:description", description], ["og:url", url], ["og:image", image], ["og:type", "website"], ["og:site_name", "FEELING MOVED"]].forEach(([k, v]) => meta("property", k, v));
  [["twitter:card", "summary_large_image"], ["twitter:title", title], ["twitter:description", description], ["twitter:image", image]].forEach(([k, v]) => meta("name", k, v));

  document.head.querySelectorAll('script[data-seo="jsonld"]').forEach((n) => n.remove());
  (s?.jsonld || []).forEach((obj) => {
    const tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.dataset.seo = "jsonld";
    tag.textContent = JSON.stringify(obj);
    document.head.appendChild(tag);
  });
};
